import React, { Component } from 'react'
import { Segment, Input, Header } from 'semantic-ui-react'
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag'

export class Uploader extends Component {
  state = {
    receivedURL: '',
  }

  render() {
    return (
      <Segment>
        <Header as="h1" content="Uploads" />
        <Mutation
          mutation={UPLOAD_FILE_MUTATION}
          update={(cache, { data: { uploadFile } }) => {
            this.setState({ receivedURL: uploadFile.url })
          }}
        >
          {uploadFile => {
            return (
              <Input
                name="upload"
                type="file"
                accept=".jpg,.png,.jpeg,.gif,.svg"
                onChange={event => {
                  const file = event.target.files[0]
                  uploadFile({ variables: { file } })
                }}
              />
            )
          }}
        </Mutation>

        <img style={{ width: '100%' }} id="upload-preview" alt="" />
        <hr />
        {decodeURIComponent(this.state.receivedURL)}
      </Segment>
    )
  }
}

const UPLOAD_FILE_MUTATION = gql`
  mutation UploadFile($file: Upload!) {
    uploadFile(file: $file) {
      url
    }
  }
`

export default Uploader
